import React, { useState, useRef } from 'react';
import { Carousel } from 'react-bootstrap';
import emailjs from 'emailjs-com';
import { storage } from './firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import './oneday.css';

import CCourseimg2 from '../../assets/courseheaderimg1.png';
import CCourseimg3 from '../../assets/courseheaderimg2.png';
import CCourseimg4 from '../../assets/courseheaderimg3.png';

function OneDayWorkShop() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    oneDayWorkshop: '',
    mealType: 'Veg',
    paymentSlip: null,
  });

  const [isSubmitting, setIsSubmitting] = useState(false); // ✅ New state to track submission
  const formRef = useRef();

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "paymentSlip") {
      if (files && files[0]) {
        const validTypes = ["image/jpeg", "image/png", "application/pdf"];
        if (!validTypes.includes(files[0].type)) {
          alert("Only JPG, PNG, or PDF files allowed!");
          return;
        }

        const maxSize = 5 * 1024 * 1024;
        if (files[0].size > maxSize) {
          alert("File too large! Max 5MB allowed.");
          return;
        }

        setFormData({ ...formData, paymentSlip: files[0] });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return; // ✅ Prevent duplicate clicks

    setIsSubmitting(true); // ✅ Lock the form
    try {
      const paymentSlipRef = ref(storage, `onedayCourse/${formData.paymentSlip.name}`);
      await uploadBytes(paymentSlipRef, formData.paymentSlip);
      const paymentSlipUrl = await getDownloadURL(paymentSlipRef);

      const emailData = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        oneDayWorkshop: formData.oneDayWorkshop,
        mealType: formData.mealType,
        paymentSlipUrl,
      };

      await emailjs.send(
        'service_u7ymc2g',
        'template_djbplsb',
        emailData,
        'hZsMgi7_QDOxxUnv0'
      );

      alert('✅ Registration successful! Your data has been saved.');

      // ✅ Clear the form
      setFormData({
        name: '',
        email: '',
        phone: '',
        address: '',
        oneDayWorkshop: '',
        mealType: 'Veg',
        paymentSlip: null,
      });

      formRef.current.reset(); // Also reset file input if needed
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('❌ There was an error submitting your registration. Please try again.');
    } finally {
      setIsSubmitting(false); // ✅ Unlock the form
    }
  };

  

  return (
    <div className='diploma-in-audiology'>
      <div className="banner-diploma">
        <Carousel className="mb-5">
          <Carousel.Item>
            <img className="d-block w-100" src={CCourseimg4} alt="First slide" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src={CCourseimg3} alt="Second slide" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100" src={CCourseimg2} alt="Third slide" />
          </Carousel.Item>
        </Carousel>
      </div>

      <div className='one-day-workshop'>
        <h1 className="registration-title">Fellowship Workshops</h1>
        <div className="registration-container">
          <h3 className="registration-subtitle">Registration</h3>
          <form className="registration-form" ref={formRef} onSubmit={handleSubmit}>
            {/* Form Fields */}
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Enter your full name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Contact Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                placeholder="Enter your phone number"
                value={formData.phone}
                onChange={handleChange}
                required
                maxLength="10"
                pattern="\d{10}"
                title="Please enter exactly 10 digits"
              />
            </div>
            <div className="form-group">
              <label htmlFor="address">Address</label>
              <input
                type="text"
                id="address"
                name="address"
                placeholder="Enter your address"
                value={formData.address}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="oneDayWorkshop">Name of Workshop</label>
              <input
                type="text"
                id="oneDayWorkshop"
                name="oneDayWorkshop"
                placeholder="Enter your workshop"
                value={formData.oneDayWorkshop}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="meal-type">Meal Type</label>
              <select
                id="meal-type"
                name="mealType"
                value={formData.mealType}
                onChange={handleChange}
                required
              >
                <option value="" disabled>Select your preference</option>
                <option value="Veg">Vegetarian</option>
                <option value="Non-Veg">Non-Vegetarian</option>
              </select>
            </div>


<div className="form-group">
  <label htmlFor="payment-slip">Upload Payment Slip (PDF, JPG, PNG - Max 5MB)</label>
  
  {/* Custom-styled upload area */}
  <div style={{
    border: `2px dashed ${formData.paymentSlip ? '#4CAF50' : '#ccc'}`,
    padding: '20px',
    textAlign: 'center',
    borderRadius: '5px',
    margin: '10px 0',
    backgroundColor: formData.paymentSlip ? '#f0fff0' : '#f9f9f9',
    cursor: 'pointer'
    }}>
      <input
        type="file"
        id="payment-slip"
        name="paymentSlip"
        accept=".jpg,.jpeg,.png,.pdf"
        onChange={handleChange}
        required
        style={{
          display: 'none' // Hide the default input
        }}
      />
      
      {/* Custom visible button */}
      <label htmlFor="payment-slip" style={{ cursor: 'pointer' }}>
        {formData.paymentSlip ? (
          <span>✅ <strong>{formData.paymentSlip.name}</strong> (Click to change)</span>
        ) : (
          <span>📁 <strong>Click to upload</strong> or drag file here</span>
        )}
    </label>
  </div>
</div>

      <div className="bank-details-container">
        <h2 className="bank-details-heading">Bank Details</h2>
        <div className="bank-detail-item">
          <strong>Account No</strong> <span> : 055010165128</span>
        </div>
        <div className="bank-detail-item">
          <strong>Account Name</strong> <span> : EYE CARE INSTITUTE (PVT) LTD</span>
        </div>
        <div className="bank-detail-item">
          <strong>Bank</strong> <span> : Hatton National Bank</span>
        </div>
        <div className="bank-detail-item">
          <strong>Branch</strong> <span> : Borella</span>
        </div>
      </div>


            
            <button 
              type="submit" 
              className="oneday-submit-button" 
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Register"}
            </button>

          </form>
        </div>
      </div>
    </div>
  );
}

export default OneDayWorkShop;